import * as z from 'zod';

import { inventoryVendorQuerySchema } from '@/_pages/settings/inventory-vendors/shared/schemas';
import { currencyInput } from '@/_schemas/generic';

export const vendorDetailsQuerySchema = z.object({
  id: z.number(),
  vendor: inventoryVendorQuerySchema,
  vendor_id: z.number(),
  inventory_id: z.number(),
  vendor_sku: z.string().nullable(),
  vendor_url: z.string().nullable(),
  last_price: currencyInput.querySchema(),
  vendor_note: z.string().nullable(),
});

export type VendorDetailsQuerySchema = z.infer<typeof vendorDetailsQuerySchema>;
